import React from 'react';
import { EMOJI_STICKERS } from '../EmojiStickerConfig';

interface EmojiPanelProps {
  visible: boolean;
  onSelect: (id: string) => void;
}

export const EmojiPanel: React.FC<EmojiPanelProps> = ({ visible, onSelect }) => {
  if (!visible) {
    return null;
  }

  return (
    <div className="message-emoji-panel">
      {EMOJI_STICKERS.map((item) => (
        <button
          key={item.id}
          type="button"
          className="message-emoji-item"
          title={item.id}
          onClick={() => onSelect(item.id)}
        >
          <img src={item.src} alt={item.id} className="message-emoji-img" />
        </button>
      ))}
    </div>
  );
};
